import React from 'react'
import PropTypes from 'prop-types'

import { components as SelectComponents } from 'react-select'

const CustomLabel = (props) => (
  <div className='react-select__value-container'>
    <div className='react-select__multi-value'>
      <div className='react-select__multi-value__label'>
        {props.option.label}
      </div>
      <div
        onClick={() => props.handleRemove(props.option)}
        className='react-select__multi-value__remove'
      >
        <SelectComponents.CrossIcon height={14} width={14} />
      </div>
    </div>
  </div>
)

CustomLabel.propTypes = {
  handleRemove: PropTypes.func.isRequired,
  option: PropTypes.object.isRequired,
}

export { CustomLabel }
